import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rcp-section-header',
  template: `
    <div class="rcp-section-header">
      <div class="section-header-content">
        <ng-content></ng-content>
      </div>

      <div class="rcp-section-header-actions global-component-style-flex-gap">
        <ng-content select="[actions]"></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./section-header.component.scss'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SectionHeaderComponent {}
